import {
  WizardSubmissionConfirmation,
  WizardSubmissionSuccess,
} from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/WizardPayment';

import useWizard from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/context/useWizard';

import { MODAL_TYPES } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/config/stepModalConstants';
import { totalCostWizardProducts } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/utils/wizardProduct';

export const WizardModalGroup = (props) => {
  const {
    wizardFormId,
    isSubmitting,
    wizardPaymentInfo,
    hasErrors,
    passedProductCount,
    passedProduct,
    onSubmissionContinue,
    onSubmitPassedProducts,
    onReviewProducts,
    onAcceptCancel,
    onCloseWizard,
  } = props;

  const { isModalOpen, closeModal } = useWizard();

  // get-payment-info doesn't consistently wrap its response in
  // { isSuccess, data, message } — fall back to the response itself
  // when it isn't wrapped.
  const paymentData = wizardPaymentInfo?.data ?? wizardPaymentInfo;
  const { isZeroCost } = totalCostWizardProducts(paymentData);

  return (
    <>
      {isModalOpen(MODAL_TYPES.CONFIRM_SUBMISSION) && (
        <WizardSubmissionConfirmation
          visible
          onCancel={() => closeModal(MODAL_TYPES.CONFIRM_SUBMISSION)}
          onContinue={() => onSubmissionContinue(wizardFormId, isZeroCost)}
          wizardPaymentInfo={paymentData}
          isSubmitting={isSubmitting}
        />
      )}

      {isModalOpen(MODAL_TYPES.ACCEPT_SUBMISSION) && (
        <WizardSubmissionSuccess
          visible
          hasErrors={hasErrors}
          passedProductCount={passedProductCount}
          passedProduct={passedProduct}
          onCancel={onAcceptCancel}
          onSubmitPassedProducts={onSubmitPassedProducts}
          onReviewProducts={onReviewProducts}
          wizardPaymentInfo={paymentData}
          onCloseWizard={onCloseWizard}
        />
      )}
    </>
  );
};
